/**
 * Propiedades de persona de PostHog que escriben a la vez el navegador (en
 * `identify` / `setPersonProperties`) y el servidor (en `purchase_completed`).
 * Un solo tipo y un solo constructor para que los dos lados no puedan divergir:
 * el contrato completo está en docs/POSTHOG_INTEGRATION.md › «Propiedades de persona».
 */
export type AccountPersonProperties = {
  email: string
  available_minutes: number
}

export function accountPersonProperties(account: { email: string; availableMinutes: number }): AccountPersonProperties {
  return { email: account.email, ...availableMinutesProperty(account.availableMinutes) }
}

/** Solo el saldo, para quien lo escribe sin el email (p. ej. al terminar una llamada). */
export function availableMinutesProperty(availableMinutes: number): Pick<AccountPersonProperties, 'available_minutes'> {
  return { available_minutes: availableMinutes }
}
